<template>
    <p>
        <strong>Ampelsystem:</strong>
        <span class="c-ranking c-ranking--red"></span> in anderer Kolonne eingeplant
        <span class="c-ranking c-ranking--yellow u-extra-small-margin--left"></span> ist nicht verfügbar
        <span class="c-ranking c-ranking--green u-extra-small-margin--left"></span> ist verfügbar
    </p>
</template>
<script>
    export default {
        name: 'KolonneSettingsEmployeesRankingLegend'
    }
</script>
